import { render, staticRenderFns } from "./teamRewardList.vue?vue&type=template&id=28d63a42&scoped=true"
import script from "./teamRewardList.vue?vue&type=script&lang=js"
export * from "./teamRewardList.vue?vue&type=script&lang=js"
import style0 from "./teamRewardList.vue?vue&type=style&index=0&id=28d63a42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d63a42",
  null
  
)

export default component.exports